(function() {

  const isWordpressBackend = !document.body;

  if(isWordpressBackend) return;

  const container = document.querySelector(".u-page-loader");
  function getScrollbarWidth() {

      // Creating invisible container
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll'; // forcing scrollbar to appear
      outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
      document.body.appendChild(outer);
  
      // Creating inner element and placing it in the container
      const inner = document.createElement('div');
      outer.appendChild(inner);
  
      // Calculating difference between container's full width and the child width
      const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
  
      // Removing temporary elements from the DOM
      outer.parentNode.removeChild(outer);
      return scrollbarWidth;
  }
  document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + "px");

  if (!location.hash && container) {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    document.addEventListener("DOMContentLoaded", function () {
      let tl = gsap.timeline({
        // yes, we can add it to an entire timeline!
        scrollTrigger: {
          trigger: container,
        },
        onComplete: self => {
          container.classList.remove('is-active');
          document.body.classList.remove('u-body--loading');
          document.querySelector(".u-page").setAttribute('style', '');

          var event = new CustomEvent('page-load-complete');
          document.dispatchEvent(event);
        },
      });

      // add animations and labels to the timeline
      tl.addLabel("start")
        .fromTo(document.querySelector(".u-page"), {translateY: '100%'}, {translateY: '0%', delay: 0, duration: 0.8, ease: Sine.easeOut })
        .addLabel("end");
    });
  } else {
    // document.body.classList.remove('u-body--loading');
    document.addEventListener("DOMContentLoaded", function () {
      var event = new CustomEvent('page-load-complete');
      document.dispatchEvent(event);
    });
  }

})();